import React from "react";

// AJMUS-WEB-PLATFORM-APPROVED-IMAGE-P6
// The platform artwork is intentionally rendered as ONE approved image.
// Do not reposition the rings, icons, labels or benefit cards independently.
// This guarantees the website matches the approved visual exactly.
export default function UnifiedPlatform() {
  return (
    <section
      id="platform"
      className="relative overflow-hidden bg-[#071a3b] text-white"
      data-testid="section-platform"
      aria-label="AJMUS connected platform"
    >
      <div className="mx-auto w-full max-w-[1672px]">
        <img
          src="/brand/ajmus-platform-approved.png"
          alt="AJMUS connected platform showing Front Desk, Operations, Finance, Inventory, HR, Reports, Communication and Management Dashboard around AJMUS Core, with integrated platform benefits."
          className="block h-auto w-full select-none"
          loading="eager"
          draggable="false"
        />
      </div>
    </section>
  );
}
